export { addressFromGoogleMapsPlace };

// See https://developers.google.com/maps/documentation/geocoding/overview#Types for types
function addressFromGoogleMapsPlace(place, options = { validateDeliverable: false }) {
  if (!place) {
    return undefined;
  }
  const {
    address_components,
    geometry: { location },
  } = place;
  const components = address_components.reduce((acc, comp) => {
    const type = comp.types[0];
    acc[type] = comp;
    return acc;
  }, {});

  if (options.validateDeliverable) {
    // TODO: Trigger sentry errors if known problems are detected. This is where we peer into the guts of the Place and find problems
  }

  const address_1 = `${components.street_number.short_name} ${components.route.short_name}${
    components?.premise ? ' ' + components.premise.short_name : ''
  }`;
  const city = components.locality?.short_name || '';
  const state = components.administrative_area_level_1.short_name;
  const country = components.country.short_name;
  const zip_code = components.postal_code.short_name;
  return {
    address_1,
    city,
    state,
    country,
    zip_code,
    latitude: location.lat(),
    longitude: location.lng(),
  };
}
